var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import { TableHeader, TableHead as StyledTHead } from '../styles';
import React from 'react';
import { TopArrow, BottomArrow, FilterArrow } from 'src/assets/Images';
function TableHead(_a) {
    var columns = _a.columns, onHeaderClick = _a.onHeaderClick, order = _a.order, rowActions = _a.rowActions;
    var finalColumns = columns;
    if (rowActions) {
        finalColumns = __spreadArrays(columns, [{ label: '', render: function () { return ''; } }]);
    }
    var headers = finalColumns.map(function (column) {
        var isClickable = column.sortingFieldName && onHeaderClick;
        var sortIcon;
        if (isClickable && (!order || order.order_by !== column.sortingFieldName)) {
            sortIcon = FilterArrow;
        }
        else if (isClickable && order.order_by === column.sortingFieldName) {
            sortIcon = order.direction === 'ASC' ? TopArrow : BottomArrow;
        }
        return (React.createElement("th", { key: column.label },
            React.createElement(TableHeader, { style: {
                    cursor: isClickable ? 'pointer' : 'auto',
                }, onClick: isClickable ? function () { return onHeaderClick(column); } : undefined },
                column.label,
                sortIcon && React.createElement("img", { width: 8, src: sortIcon }))));
    });
    return (React.createElement(StyledTHead, null,
        React.createElement("tr", null, headers)));
}
export default TableHead;
